import {createFileRoute} from '@tanstack/react-router'
import CoachesEdit from "../../../../components/coaches/CoachesEdit.tsx";
import Content from "../../../../components/Content.tsx";
import Header from "../../../../Header.tsx";

export const Route = createFileRoute('/_app/organizer/coaches/$coach_uid')({
    component:  RouteComponent,
    staticData: {
        backUrl: '/organizer/coaches',
    }
})

function RouteComponent() {
    return <>
        <Header />

        <Content>
            <CoachesEdit />
        </Content>
    </>
}
